import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ArrowBackBlue } from 'Images';

interface IOpenClose {
  isOpen: Boolean;
}

export const OpenClose = ({ isOpen }: IOpenClose) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Suppliers).resultPage;
  const isDesktop = useIsDesktop();

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent={isDesktop ? 'flex-end' : 'center'}
      gap='4px'
      sx={{
        mt: isDesktop ? undefined : '24px',
        minWidth: '126px',
        width: isDesktop ? 'fit-content' : undefined,
        height: 'fit-content',

        ':hover': {
          cursor: 'pointer',
          textDecoration: 'underline',
        },
      }}
    >
      <Typography
        variant='body3'
        sx={{
          color: 'primary.main',
          whiteSpace: 'nowrap',
        }}
      >
        {isOpen ? dictionary.close : dictionary.moreInfo}
      </Typography>
      <Avatar
        alt=''
        src={ArrowBackBlue}
        sx={{
          width: '16px',
          height: '16px',
          transform: isOpen ? 'rotate(90deg)' : 'rotate(-90deg)',
        }}
      />
    </Stack>
  );
};
